cb.define(function() {
	var AA_business_option_VM_Extend = {
		doAction: function(name, viewmodel) {
			if (this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			var self = this;
			/*var billdefaulttypeModel = viewmodel.get('billdefaulttype');
			billdefaulttypeModel.setState('dataSourceMode', 'remote');
			billdefaulttypeModel.setState('valueField', 'templatecode');
			billdefaulttypeModel.setState('textField', 'templatename');
			billdefaulttypeModel.setDataSource({
			  url: 'print/getTemplateByBo',
			  method: 'GET'
			}, { billno: 'rm_retailvouch' });*/

			viewmodel.get('demandsalesrefcycle').setState('min',0)
			var pointQuerySchemeModel = viewmodel.get('pointQueryScheme');
			pointQuerySchemeModel.setState('allowClear', false);
			pointQuerySchemeModel.setState('dataSourceMode', 'remote');
			pointQuerySchemeModel.setState('valueField', 'id');
			pointQuerySchemeModel.setState('textField', 'name');
			pointQuerySchemeModel.setDataSource({
				url: 'report/getGroupSchema',
				method: 'GET'
			}, {
				billnum: 'stock_stockanalysis'
			});
			var dailyInventoryDailyPlanModel = viewmodel.get('dailyInventoryDailyPlan');
			dailyInventoryDailyPlanModel.setState('allowClear', false);
			dailyInventoryDailyPlanModel.setState('dataSourceMode', 'remote');
			dailyInventoryDailyPlanModel.setState('valueField', 'id');
			dailyInventoryDailyPlanModel.setState('textField', 'name');
			dailyInventoryDailyPlanModel.setDataSource({
				url: 'report/getGroupSchema',
				method: 'GET'
			}, {
				billnum: 'stock_stockanalysis'
			});
			viewmodel.on("afterLoad", function(data) {
				/*var paymenttypevalue = viewmodel.get("enablemaling").getValue();
				var billprinttype = viewmodel.get("billprinttype").getValue();*/
				var ERPsyscheckoutdate = viewmodel.get("ERPsyscheckoutdate");
				/*if(ERPsyscheckoutdate != undefined)
					//ERPsyscheckoutdate.setReadOnly(true);
				if(billprinttype === "1")
					viewmodel.get("billingcopiesofprintcopies").setReadOnly(false);
				else
					viewmodel.get("billingcopiesofprintcopies").setReadOnly(true);
				
				if(!paymenttypevalue) {
					viewmodel.get("malingdefault").setReadOnly(true);
					viewmodel.get("malingcalobject").setReadOnly(true);
					viewmodel.get("malingprecision").setReadOnly(true);
					viewmodel.get("malingmode").setReadOnly(true);
				}else{
					viewmodel.get("malingdefault").setReadOnly(false);
					viewmodel.get("malingcalobject").setReadOnly(false);
					viewmodel.get("malingprecision").setReadOnly(false);
					viewmodel.get("malingmode").setReadOnly(false);
				}*/
			});
			/*viewmodel.get('billprinttype').on('afterValueChange', function(data) {
				if(data.value.value === "1")
					viewmodel.get("billingcopiesofprintcopies").setReadOnly(false);
				else
					viewmodel.get("billingcopiesofprintcopies").setReadOnly(true);
			});*/
			/*viewmodel.get('enablemaling').on('afterValueChange', function(data) {
				if(data.value.value == "false"){
				viewmodel.get("malingdefault").setReadOnly(true);
				viewmodel.get("malingcalobject").setReadOnly(true);
				viewmodel.get("malingprecision").setReadOnly(true);
				viewmodel.get("malingmode").setReadOnly(true);
			}else if(data.value.value == "true"){
				viewmodel.get("malingdefault").setReadOnly(false);
				viewmodel.get("malingcalobject").setReadOnly(false);
				viewmodel.get("malingprecision").setReadOnly(false);
				viewmodel.get("malingmode").setReadOnly(false);
			}
		});*/
		}
	}
	try {
		module.exports = AA_business_option_VM_Extend;
	} catch (error) {

	}
	return AA_business_option_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_business_option_VM.Extend.js